/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { AccommodationInvoiceState } from '../state/AccommodationInvoiceState'
import AccommodationInvoiceEvent from '../../event/AccommodationInvoiceEvent'

class AccommodationInvoiceStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AccommodationInvoiceState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccommodationInvoiceEvent.fetchOne:
        return state.mergeModel(payload.invoice)

      case AccommodationInvoiceEvent.createStart:
        return state.clear().set('status', 'invoicing')

      case AccommodationInvoiceEvent.onEdit:
        // return state.set(payload.name, payload.value)
        return state

      default:
        return state
    }
  }
}

export default new AccommodationInvoiceStore()
